import css from './nft-item.module.scss';
import {NFTItemProps} from './nft-item.types';

export const NFTItem = (props: NFTItemProps): JSX.Element => {
	return (
		<div onClick={() => props.onClick(props.name)} className={css.container}>
			<div className={css.imageContainer}>
				<img width={40} src={props.img} />
			</div>
			<div>
				<div>{props.name}</div>
				<div className={css.time}>voted {props.voted} days ago</div>
			</div>
			<div className={css.rightBox}>
				<div className={css.value}>{props.value}</div>
				<img width={9} src="/img/arrowLeft.svg" />
			</div>
		</div>
	);
};
